import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyLabDiscussionRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/labs_discussions/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    search: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/SalesRepDiscussions/SalesRepDiscussionPage/SalesRepDiscussionPage').then(
    (d) => d.Route
  )
);
